import axios from 'axios'

export const getTutorial = (name) => {
  return axios.get(`/tutorials/${name}`)
}
